module.exports = __webpack_public_path__ + "static/media/logo.c26a493d.png";